import { OrderListItem, OrderStatus } from '@shared/model/order';
import { OrderTagData } from './types';
import { OrganizationManager } from '@shared/model/organization';
import { userName } from '@shared/lib/utils/user-name/user-name';

export const orderStatusTag = ({
    order,
    manager,
}: {
    order: OrderListItem;
    manager?: OrganizationManager | null;
}): OrderTagData | null => {
    switch (order.status) {
        case OrderStatus.Completed: {
            return {
                text: 'Приобретено',
                variant: 'green',
            };
        }
        case OrderStatus.OnPayment: {
            return {
                text: 'Ожидает оплаты',
                variant: 'yellow',
            };
        }
        case OrderStatus.OrderForming: {
            return {
                text: 'Создано',
                variant: 'grey',
            };
        }
        case OrderStatus.OrderReject: {
            return {
                text: 'Отклонено',
                variant: manager ? 'declined' : 'red',
                declineMessage: {
                    message: order.comment || 'коммент',
                    managerName: userName({
                        firstName: manager?.firstName,
                        lastName: manager?.lastName,
                        middleName: manager?.middleName,
                    }).full,
                    managerAvatarUrl: manager?.photoUrl || '',
                },
            };
        }
    }

    return null;
};
